var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThreatType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5459 14.6327L13.5689 2.36085C12.9956 1.40959 12.0045 0.833984 10.94 0.833984C9.87551 0.833984 8.88446 1.40959 8.31113 2.36085L1.3341 14.6327C0.832472 15.5196 0.815133 16.6229 1.28862 17.527C1.83621 18.545 2.85798 19.1716 3.96299 19.1671H17.917C19.0145 19.1796 20.0346 18.5687 20.5914 17.5656C21.0791 16.6516 21.0617 15.5292 20.5459 14.6327Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.5459 14.6327L13.5689 2.36085C12.9956 1.40959 12.0045 0.833984 10.94 0.833984C9.87551 0.833984 8.88446 1.40959 8.31113 2.36085L1.3341 14.6327C0.832472 15.5196 0.815133 16.6229 1.28862 17.527C1.83621 18.545 2.85798 19.1716 3.96299 19.1671H17.917C19.0145 19.1796 20.0346 18.5687 20.5914 17.5656C21.0791 16.6516 21.0617 15.5292 20.5459 14.6327ZM10.94 15.3081C10.4376 15.3081 10.0304 14.8761 10.0304 14.3433C10.0304 13.8105 10.4376 13.3785 10.94 13.3785C11.4424 13.3785 11.8497 13.8105 11.8497 14.3433C11.8497 14.8761 11.4424 15.3081 10.94 15.3081ZM10.94 12.4137C11.4424 12.4137 11.8497 11.9818 11.8497 11.449V7.5899C11.8497 7.05707 11.4424 6.62513 10.94 6.62513C10.4376 6.62513 10.0304 7.05707 10.0304 7.5899V11.449C10.0304 11.9818 10.4376 12.4137 10.94 12.4137Z",
    fill: "url(#paint0_linear_14791_169707)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14791_169707",
    x1: 0.945312,
    y1: 0.833984,
    x2: 19.2095,
    y2: 20.7585,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0054EC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0343B7"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreatType);
export default __webpack_public_path__ + "static/media/threatType.94d918a484f955b178cf85a09a677add.svg";
export { ForwardRef as ReactComponent };